export enum BulkAction {
    JIT = 'JIT',
    FENCING = 'FENCING'
}

export type BulkPolicyCreationResponse = {
    status: number | null;
    error: string | null;
    data: {
        updatesCount: number;
    } | null;
};

export interface CreateBulkPolicyProps {
    accountGuids: string[];
    open: boolean;
    onClose: (e: any, reason: string) => void;
    onSave: (message: string) => void;
    onError: (error: string) => void;
    shouldVerifyAction: boolean;
}
